import { useEffect, useState } from 'react';
import { Hourglass } from 'lucide-react';
import QuestTimeline, { type PastQuest } from '@/components/QuestTimeline';

/**
 * Embeddable preview used by the admin panel inside an iframe.
 * Listens for postMessage({ type: 'kquest:preview', quests: PastQuest[] })
 * and re-renders the live <QuestTimeline /> with the supplied data.
 *
 * No mock data — empty by default; the admin pushes the working state.
 */
export default function TimelinePreview() {
  const [quests, setQuests] = useState<PastQuest[]>([]);
  const [received, setReceived] = useState(false);

  useEffect(() => {
    function onMessage(e: MessageEvent) {
      const data = e.data;
      if (data && typeof data === 'object' && data.type === 'kquest:preview') {
        if (Array.isArray(data.quests)) {
          setQuests(data.quests);
          setReceived(true);
        }
      }
    }
    window.addEventListener('message', onMessage);
    window.parent?.postMessage({ type: 'kquest:preview-ready' }, '*');
    return () => window.removeEventListener('message', onMessage);
  }, []);

  return (
    <div className="min-h-screen bg-kquest-950">
      {quests.length === 0 ? (
        <div className="flex items-center justify-center min-h-screen p-6">
          <div className="kblock p-12 text-center max-w-md">
            <Hourglass className="w-12 h-12 text-violet-400 mx-auto mb-4 opacity-70" />
            <h2 className="font-pixel text-xl mb-2 text-kquest-100">
              {received ? 'Nessuna quest da mostrare' : 'In attesa dei dati…'}
            </h2>
            <p className="text-sm text-kquest-300 leading-relaxed">
              {received
                ? 'Aggiungi una quest passata dal pannello a sinistra. Apparirà qui in tempo reale.'
                : 'Modifica i campi a sinistra per vedere il risultato live.'}
            </p>
          </div>
        </div>
      ) : (
        <QuestTimeline pastQuests={quests} />
      )}
    </div>
  );
}
